import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'xux-drawer-sidebar',
  templateUrl: './xux-drawer-sidebar.component.html',
  styleUrls: ['./xux-drawer-sidebar.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class XUXDrawerSidebarComponent {}
